<template>
  <div
    class="table"
    :class="{
      blur: (!$store.getters['user/data'].subsPlan)
    }"
  >
    <app-btn to="/dashboard/plans" class="go-to-plans" v-if="!$store.getters['user/data'].subsPlan">{{$ml.get(`Get the full access to the software`)}}</app-btn>

    <table class="a-table">
      <tr class="head-sm">
        <td>{{$ml.get(`STAGE NAME`)}}</td>
        <td>{{$ml.get(`BLEND GRADE (N-P-K)`)}}</td>
        <td>{{$ml.get(`LOAD WEIGHT`)}}</td>
        <td>{{$ml.get(`BLEND COMPOSITION`)}}</td>
        <td>{{$ml.get(`BLEND TO APPLY`)}}</td>
        <td>{{$ml.get(`LOADS`)}}</td>
      </tr>
      <tr v-for="stage in table.Stages">
        <td class="h-bold">
          <div class="mobile-only">{{$ml.get(`STAGE NAME`)}}: </div>
          {{ stage.StageName }}
        </td>
        <td style="white-space:nowrap;">
          <div class="mobile-only">{{$ml.get(`BLEND GRADE (N-P-K)`)}}: </div>
          {{ stage.LoadName }}
        </td>
        <td>
          <div class="mobile-only">{{$ml.get(`LOAD WEIGHT`)}}: </div>
          <input class="input-number" @keypress="validate" type="number" v-model="stage.LoadWeight">
        </td>
        <td>
          <div class="mobile-only">{{$ml.get(`BLEND COMPOSITION`)}}: </div>
          <p v-for="fertilizer in stage.Fertilizers" class="bullet">
              <!-- - {{ fertilizer.Name }} - {{ ( stage.LoadWeight / table.LoadWeight  * fertilizer.Concentration ).toFixed(3) }} kg -->
              - {{ $ml.get(fertilizer.Name) }} - {{ $store.getters['unit/convert']('kg', stage.LoadWeight / table.LoadWeight  * fertilizer.Concentration) }} {{$store.getters['unit/getLabel']('kg')}}
          </p>
        </td>
        <td>
          <div class="mobile-only">{{$ml.get(`BLEND TO APPLY`)}}: </div>
          <!-- {{ (stage.BlendToApply).toFixed(3) }} kg -->
          {{ $store.getters['unit/convert']('kg', stage.BlendToApply) }} {{$store.getters['unit/getLabel']('kg')}}
        </td>
        <td>
          <div class="mobile-only">{{$ml.get(`LOADS`)}}: </div>
          <template v-if="stage.BlendToApply / stage.LoadWeight > 1">
            {{ (stage.BlendToApply / stage.LoadWeight).toFixed(2) }} 
          </template>
          <template v-else>
            {{  (stage.BlendToApply / stage.LoadWeight* 100).toFixed(2)}}%
          </template>
        </td>
        <!-- <td>
          <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.13115 7H10.3765M2.90461 12.5H0.829102V4.5H12.452V12.5H10.3765H2.90461ZM2.90461 9.5V15H10.3765V9.5H2.90461ZM10.3765 4.5V1H2.90461V4.5H10.3765Z" stroke="#568129" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </td> -->
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {

  },
  computed: {
    ...mapGetters({
      table: 'program/blend/table',
    }),
  },
  methods: {
    validate(e) {
     let charCode = String.fromCharCode(e.keyCode)
      if(!(/[0-9.,]/).test(charCode)) {
        e.preventDefault();
      } else {
        if((/,/).test(charCode)) {
          console.log(e)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-number {
  -moz-appearance: textfield;
}
.input-number::-webkit-outer-spin-button,
.input-number::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.table {
  padding: 40px 0;

  table {
    width: 100%;
    td {
      padding: 12px 4px;
      input[type="number"] {
        width: 100px;
        padding: 8px 12px 8px 12px;
        background-color: #fff;
        border: 1px solid $mainGreen;
        border-radius: 3px;
        outline: none;
        color: $mainGreen;
        font-size: 16px;
        height: 42px;
        &::-webkit-inner-spin-button {
          opacity: 1;
        }
      }
    }
  }
  .bullet {
    margin-top: 0;
    margin-bottom: 8px;
    font-size: 14px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .head-sm {

  }
  @media (max-width: 1100px) {
    padding: 40px 0;
  }
  @media (max-width: 768px) {
    overflow-x: scroll;
    padding-bottom: 0;
    table {
      tr {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid #e0e0e0;
        margin-bottom: 24px;
        padding-bottom: 16px;
        &.head-sm {
          display: none;
        }
        .mobile-only {
          padding-bottom: 4px;
          font-weight: bold;
          font-size: 14px;
        }
        td {
          border-bottom: none;
          &.h-bold {
            font-weight: 400;
          }
        }
      }
    }
  }
}

</style>
